// @ts-check
import axios from 'axios'

const BASE = '/api/personal-analyst/cm-qa-scorecards'

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {Schemas['AuditQueueFilter']} AuditQueueFilter */
/** @typedef {Schemas['AuditQueueItem']} AuditQueueItem */

/**
 * GET /api/personal-analyst/cm-qa-scorecards/ -- list scorecards by care manager.
 * @param {{ window?: number }} [params]
 * @returns {Promise<{ window: number, results: object[] }>}
 */
export async function listScorecards(params) {
  const { data } = await axios.get(`${BASE}/`, { params })
  return data
}

/**
 * GET /api/personal-analyst/cm-qa-scorecards/report/ -- aggregate QA report.
 * @returns {Promise<object>}
 */
export async function getReport() {
  const { data } = await axios.get(`${BASE}/report/`)
  return data
}

/**
 * GET /api/personal-analyst/cm-qa-scorecards/rubrics/ -- list configured rubrics.
 * @returns {Promise<{ results: object[] }>}
 */
export async function listRubrics() {
  const { data } = await axios.get(`${BASE}/rubrics/`)
  return data
}

/**
 * POST /api/personal-analyst/cm-qa-scorecards/audit-queue/ -- paginated audit queue.
 * @param {AuditQueueFilter} [filters]
 * @param {{ limit?: number, offset?: number }} [pagination]
 * @returns {Promise<{ count: number, results: AuditQueueItem[] }>}
 */
export async function listAuditQueue(filters = {}, pagination = {}) {
  const params = {}
  if (pagination.limit) params.limit = pagination.limit
  if (pagination.offset) params.offset = pagination.offset
  const { data } = await axios.post(`${BASE}/audit-queue/`, filters, { params })
  return data
}

/**
 * GET /api/personal-analyst/cm-qa-scorecards/calls/ -- calls for a care manager.
 * @param {number} careManagerUserId
 * @returns {Promise<{ results: object[] }>}
 */
export async function listCalls(careManagerUserId) {
  const { data } = await axios.get(`${BASE}/calls/`, {
    params: { care_manager_user_id: careManagerUserId },
  })
  return data
}

/**
 * POST /api/personal-analyst/cm-qa-scorecards/submit-audit/ -- submit a human audit.
 * @param {object} body
 * @returns {Promise<object>}
 */
export async function submitAudit(body) {
  const { data } = await axios.post(`${BASE}/submit-audit/`, body)
  return data
}
